"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _antd = require("antd");

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var _default = function _default(a) {
  return _react["default"].createElement(_antd.Input, _extends({}, a, {
    onChange: function onChange(b) {
      return a.onChange(b.target.value);
    }
  }));
};

exports["default"] = _default;